/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add-icon': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" _fill="#707070" d="M1 7h13v1H1z"/><path pid="1" _fill="#707070" d="M8 1v13H7V1z"/>'
  }
})
